<template>
  <v-container fluid class="py-0">
    <v-row justify="center" v-if="!config.DASHBOARD_SCREEN_URLS">
      <v-col cols="12" sm="6">
        <v-card>
          <v-card-title>
            Welcome!
          </v-card-title>
          <v-card-text>
            <router-link
            :to="{ path: '/profile/' }"
            >
            Please <span>click here</span> to set your favourite screens as your dashboard!
          </router-link>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  <v-row v-else>
    <v-col cols="12" class="pa-0">
      <v-card flat tile>
        <v-card-actions class="pb-0 text-center" v-if="config.DASHBOARD_SCREEN_URLS.length > 1">
          <v-flex xs4>
            <v-item-group v-model="screen" mandatory>
              <v-item
              v-for="n in config.DASHBOARD_SCREEN_URLS.length"
              :key="`btn-${n}`"
              v-slot:default="{ active, toggle }"
              >
              <v-btn :input-value="active" icon @click="toggle">
                <v-icon>mdi-record</v-icon>
              </v-btn>
            </v-item>
          </v-item-group>
        </v-flex>
        <v-flex xs4>
          <span class="title">{{config.DASHBOARD_SCREEN_NAMES[screen]}}</span>
        </v-flex>
        <v-flex xs3>
          <v-btn icon :input-value="isSlideShow">
            <v-icon @click="runSlides">
              {{isSlideShow ? 'mdi-stop-circle-outline' : 'mdi-play-circle-outline'}}
            </v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs1 class="text-left">
          <span class="ml-2" v-if="isSlideShow">{{secToWait}}</span>
        </v-flex>
      </v-card-actions>
      <div v-else class="text-center">
        <span class="title">{{config.DASHBOARD_SCREEN_NAMES[screen]}}</span>
      </div>
      <v-card-text class="pa-0">
        <v-window v-model="screen">
          <v-window-item v-for="(comp, i) in config.DASHBOARD_SCREEN_URLS" :key="i" >
            <component :is="comp"></component>
          </v-window-item>
        </v-window>
      </v-card-text>
    </v-card>
  </v-col>
</v-row>
</v-container>
</template>

<script>
import config from '@/config/app-cfg'

export default {
  components: {
    // possible screens that the user can place in dashboard
    // To do: uncomment them as the component made available
    attendance: () => import('@/components/Attendance'),
    backofficedash: () => import('@/components/BackOfficeDash'),
    backofficesup: () => import('@/components/BackOfficeSup'),
    // bookings: () => import('@/components/Bookings'),
    bositevisit: () => import('@/components/BOSiteVisit'),
    // community: () => import('@/components/Community'),
    compensation: () => import('@/components/Compensation'),
    // complaints: () => import('@/components/Complaints'),
    // compset: () => import('@/components/Compset'),
    consolidatereports: () => import('@/components/ConsolidateReports'),
    coodash: () => import('@/components/Coodash'),
    dailyreport: () => import('@/components/DailyReport'),
    // dashboard: () => import('@/components/Dashboard'),
    dashboardview: () => import('@/components/DashboardView'),
    deboardreview: () => import('@/components/DeboardReview'),
    // desig: () => import('@/components/Desig'),
    employee: () => import('@/components/Employee'),
    facdash: () => import('@/components/Facdash'),
    facility: () => import('@/components/Facility'),
    fmupdate: () => import('@/components/Fmupdate'),
    hints: () => import('@/components/Hints'),
    hrdash: () => import('@/components/Hrdash'),
    invoicetracker: () => import('@/components/InvoiceTracker'),
    mandash: () => import('@/components/Mandash'),
    miconfig: () => import('@/components/Miconfig'),
    onboardreview: () => import('@/components/OnboardReview'),
    opdash: () => import('@/components/Opdash'),
    operationreview: () => import('@/components/OperationReview'),
    payroll: () => import('@/components/Payroll'),
    payrollprocess: () => import('@/components/PayrollProcess'),
    profile: () => import('@/components/Profile'),
    projbilling: () => import('@/components/ProjBilling'),
    projcontract: () => import('@/components/ProjContract'),
    project: () => import('@/components/Project'),
    // rate: () => import('@/components/Rate'),
    repository: () => import('@/components/Repository'),
    // resident: () => import('@/components/Resident'),
    // roles: () => import('@/components/Roles'),
    salesreview: () => import('@/components/SalesReview'),
    services: () => import('@/components/Services'),
    shifts: () => import('@/components/Shifts'),
    smartdash: () => import('@/components/Smartdash'),
    staff: () => import('@/components/Staff'),
    subvendor: () => import('@/components/Subvendor'),
    task: () => import('@/components/Task'),
    tickets: () => import('@/components/Tickets'),
    ticketssla: () => import('@/components/Ticketssla'),
    uniformconfig: () => import('@/components/UniformConfig'),
    uniformtracking: () => import('@/components/UniformTracking'),
    unisubscriptions: () => import('@/components/UniSubscriptions'),
    // userroles: () => import('@/components/Userroles'),
    // users: () => import('@/components/Users'),
    vendorsupplier: () => import('@/components/Vendorsupplier'),
    // waterqual: () => import('@/components/Waterqual'),
  },
  data () {
    return {
      config: config,
      screen: 0,
      isSlideShow: false,
      timer: '',
      counter: '',
      SLIDE_DELAY: 20,
      secToWait: ''
    }
  },
  methods: {
    next () {
      this.screen = this.screen + 1 === config.DASHBOARD_SCREEN_URLS.length ? 0 : this.screen + 1
      this.secToWait = this.SLIDE_DELAY
    },
    prev () {
      this.screen = this.screen - 1 < 0 ? config.DASHBOARD_SCREEN_URLS.length - 1 : this.screen - 1
    },
    runSlides () {
      this.isSlideShow = !this.isSlideShow
      config.SHOW_APP_DRAWER = !this.isSlideShow
      if (this.isSlideShow) {
        this.secToWait = this.SLIDE_DELAY
        this.counter = setInterval(() => {
          this.secToWait--
        }, 1000)
        this.timer = setInterval(this.next, this.SLIDE_DELAY * 1000)
      } else {
        console.log('clearing timers')
        clearInterval(this.timer)
        clearInterval(this.counter)
      }
    },
    beforeDestroy () {
      console.log('clearing timers')
      clearInterval(this.timer)
      clearInterval(this.counter)
    }
  }
}
</script>
